import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBase, getAuthHeaders } from '../../utils/api';

export default function SafeEmailPreview({ html = '', plain = false, title = 'Email preview' }) {
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    let active = true;
    setPreview(null);
    axios.post(`${getApiBase()}/email-preview`, { html, plain }, { headers: getAuthHeaders() })
      .then(({ data }) => { if (active) setPreview({ source: html, plain, document: data.html }); })
      .catch(() => { if (active) setPreview({ source: html, plain, failed: true }); });
    return () => { active = false; };
  }, [html, plain]);
  if (!preview || preview.source !== html || preview.plain !== plain) return <p>Loading email preview…</p>;
  if (preview.failed) return <pre className="whitespace-pre-wrap break-words">{html}</pre>;
  return <iframe title={title} sandbox="" referrerPolicy="no-referrer" srcDoc={preview.document}
    className="w-full border rounded bg-white" style={{ minHeight: 400 }} />;
}
